import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, catchError, map, of } from 'rxjs';
import { SaleService } from '../services/sale.service';

@Injectable({
  providedIn: 'root',
})
export class SaleGuard implements CanActivate {
  constructor(
    private saleService: SaleService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const functionId = route.queryParams['functionId'];

    if (!functionId) {
      this.router.navigate(['/']);
      return of(false);
    }

    // Verificar si hay una venta activa
    return this.saleService.getSale().pipe(
      map((currentSale) => {
        // Si la venta activa es de la misma función, permitir el acceso
        if (currentSale.function.id === functionId) {
          return true;
        }

        // Si es de otra función, preguntar al usuario
        const shouldContinue = confirm(
          `Tienes una compra en proceso para otra función (${currentSale.movie.name}). ` +
            '¿Quieres cancelar esa compra y empezar una nueva?'
        );

        if (shouldContinue) {
          // El usuario quiere empezar nueva compra
          return true;
        } else {
          // Redirigir a la compra actual
          this.router.navigate(['/checkout'], {
            queryParams: {
              movieId: currentSale.movie.id,
              functionId: currentSale.function.id,
            },
          });
          return false;
        }
      }),
      catchError(() => {
        // No hay venta activa, permitir el acceso
        return of(true);
      })
    );
  }
}
